import React, { Component } from 'react';
import { firebaseAuth,ref } from '../config/constants'


import Sidebar from './inc/Sidebar';
import Header from './inc/Header';
import Title from './inc/Title';
import Footer from './inc/Footer';


class EditCategory extends Component {

    constructor(){
        super();
        this.updateCategory = this.updateCategory.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.state = {
            userId:"",
            user :{},
            errorMsg : "",
            categoryToBeUpdate : {}
        };
    }
    
    componentWillMount() {

        this.listener = firebaseAuth().onAuthStateChanged(user=>{
            if (user){
                var db = ref.child("users").child(user.uid);
                    db.on("value",function(data){
                      
                      this.setState({
                        userId:data.key,
                        user:data.val()
                      });

                    }.bind(this));
            }else{
              this.props.history.push("/login");
            }
        });

        var unit = ref.child("Categories").child(this.props.match.params.cid)
            unit.on("value", function(snap){
                this.setState({
                    categoryToBeUpdate : snap.val()
                })
            }.bind(this))   
    }

    componentWillUnmount(){
      this.listener()
    }

    updateCategory(e){
         e.preventDefault();

        const updatedCategory=this.state.categoryToBeUpdate;
        ref.child("Categories").child(this.props.match.params.cid).update(updatedCategory).then(()=>{
        alert("Category updated successfully")
        });
    }
    handleChange(e){
        let updateCategory = this.state.categoryToBeUpdate;
        let update ={
            ...updateCategory,
            [e.target.name]:e.target.value
        } 
        this.setState({categoryToBeUpdate:update})
    }

    render() {
      
        return (
            <div id="page-wrapper">
                <div id="page-container" className="sidebar-partial sidebar-visible-lg sidebar-no-animations">
                    <Sidebar  role={this.state.user.role} />
                    <div id="main-container">
                        <Header />
                        <div id="page-content">
                            <Title title="Category" />
                            <div className="block">
                                <form className="form-horizontal form-bordered" ref={(input) => {this.categoryUpdateForm=input}}  onSubmit={(e)=>this.updateCategory(e)}>
                                    <div className="form-group">
                                        <label className="col-md-3 control-label" htmlFor="category-name">Category</label>
                                        <div className="col-md-4">
                                            <input className="form-control" value={this.state.categoryToBeUpdate.category} name="category" type="text" onChange={this.handleChange} />
                                        </div>
                                    </div>
                                                                       
                                    <div className="form-group form-actions">
                                        <div className="col-md-9 col-md-offset-3">
                                            <button type="submit" className="btn btn-sm btn-primary"><i className="fa fa-floppy-o"></i> Update Category</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                                
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>
      
        );
    }
}

export default EditCategory;



// WEBPACK FOOTER //
// ./src/components/EditCategory.js